import { render, staticRenderFns } from "./formMeasurementData.vue?vue&type=template&id=49cc3b5c&scoped=true"
import script from "./formMeasurementData.vue?vue&type=script&lang=js"
export * from "./formMeasurementData.vue?vue&type=script&lang=js"
import style0 from "./formMeasurementData.vue?vue&type=style&index=0&id=49cc3b5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc3b5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49cc3b5c')) {
      api.createRecord('49cc3b5c', component.options)
    } else {
      api.reload('49cc3b5c', component.options)
    }
    module.hot.accept("./formMeasurementData.vue?vue&type=template&id=49cc3b5c&scoped=true", function () {
      api.rerender('49cc3b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/trailer/components/form/steps/formMeasurementData.vue"
export default component.exports